import { WinFrequency, type WinFrequencyResponse } from '@fanduel/casino-swj-consumer';
import type { Region } from '@/types/constants';
import { DD_USE_CASES, type TRumError, type IddUseCases } from '@/utils/datadog/types';
import { getConfig } from '@/utils/config/config';
import { COOKIES } from '@/utils/cookies';
import { getCookieValue } from '@/utils/cookies/client';
import { ddRumAction } from '@/utils/datadog';
import { buildApiUrl } from '@/utils/url/build-url';
import { useEffect, useState } from 'react';

const ddErrorSwjWinFrequency = (context: { jackpotId: string }, use_case: IddUseCases): TRumError => ({
    name: 'SWJ_GET_WIN_FREQUENCY_FAILED',
    description: 'Site wide jackpot get win frequency failed',
    context,
    use_case
});

export const useWinFrequency = (jackpotId: string) => {
    const [tierWinFrequency, setTierWinFrequency] = useState<Record<string, number> | undefined>();

    const mapData = (data?: WinFrequencyResponse) => {
        const matchingJackpot = data?.find((d) => d.jackpotRef === jackpotId);

        if (!matchingJackpot) {
            setTierWinFrequency({});
            return;
        }

        const tierWinFreq = matchingJackpot.tiersNumberOfWins.reduce((acc: Record<string, number>, curr) => {
            acc[curr.tierRef] = curr.numberOfWins;
            return acc;
        }, {});

        setTierWinFrequency(tierWinFreq);
    };

    useEffect(() => {
        const config = getConfig();
        const region = getCookieValue(COOKIES.REGION) as Region;

        const winFrequency = new WinFrequency({
            host: buildApiUrl(config?.apis?.SiteWideJackpotClient).replace('statePlaceholder', region),
            region,
            interval: 0,
            timeInterval: 'last24h',
            jackpotIds: [jackpotId],
            callback: mapData,
            error: () => ddRumAction(ddErrorSwjWinFrequency({ jackpotId: jackpotId }, DD_USE_CASES.SITE_WIDE_JACKPOT))
        });

        winFrequency.connect();

        return () => {
            winFrequency.disconnect();
        };
    }, [jackpotId]);

    return { tierWinFrequency, mapData };
};
